/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { RoleBadge } from './RoleBadge';
import { Pill } from './Pill';

interface TurnBlockProps {
  turn: ChatTurn;
}

const fmtTime = (iso: string) => {
  const d = new Date(iso);
  const hh = d.getHours().toString().padStart(2, '0');
  const mm = d.getMinutes().toString().padStart(2, '0');
  const ss = d.getSeconds().toString().padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
};

export const TurnBlock: React.FC<TurnBlockProps> = ({ turn }) => {
  return (
    <div css={turnBlockStyles}>
      <div css={headerStyles}>
        <Pill>
          User: {turn.USER_NAME} -{turn.USER_ID}
        </Pill>

        <Pill>Ngày: {new Date(turn.ASKED_AT).toLocaleDateString()}</Pill>
      </div>

      {/* User question */}
      <div css={messageRowStyles}>
        <div css={timeStyles}>{fmtTime(turn.ASKED_AT)}</div>
        <div css={roleStyles}>
          <RoleBadge role='User' />
        </div>
        <div css={messageStyles(true)}>
          <p css={textStyles}>{turn.CONTENT}</p>
        </div>
      </div>

      {/* Chatbot answer */}
      {turn.RESPONSE ? (
        <div css={messageRowStyles}>
          <div css={timeStyles}>{fmtTime(turn.ANSWERED_AT)}</div>
          <div css={roleStyles}>
            <RoleBadge role='Chatbot' />
          </div>
          <div css={messageStyles(false)}>
            <p css={textStyles}>{turn.RESPONSE}</p>
          </div>
        </div>
      ) : (
        <div css={messageRowStyles}>
          <div css={[timeStyles, { color: '#9ca3af' }]}>—</div>
          <div css={roleStyles}>
            <RoleBadge role='Chatbot' />
          </div>
          <div css={noAnswerStyles}>Chưa có câu trả lời</div>
        </div>
      )}
    </div>
  );
};

const turnBlockStyles = css`
  border-radius: 1.6rem;
  border: 1px solid #e5e7eb;
  padding: 1.2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background: white;
`;

const headerStyles = css`
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 1.2rem;
  color: #6b7280;
`;

const messageRowStyles = css`
  display: grid;
  grid-template-columns: 10rem 11rem 1fr;
  align-items: center;
  gap: 1.2rem;
  padding: 0.4rem 0;
`;

const timeStyles = css`
  font-size: 1.2rem;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
`;

const roleStyles = css`
  display: flex;
  align-items: center;
`;

const messageStyles = (isUser: boolean) => css`
  border-radius: 1.6rem;
  border: 1px solid ${isUser ? '#bfdbfe' : '#a7f3d0'};
  background: white;
  padding: 1.2rem;
  line-height: 1.6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const noAnswerStyles = css`
  border-radius: 1.6rem;
  border: 1px dashed #d1d5db;
  background: #f9fafb;
  padding: 1.2rem;
  font-size: 1.4rem;
  color: #6b7280;
`;

const textStyles = css`
  white-space: pre-wrap;
  word-break: break-words;
  font-size: 1.4rem;
  color: #1f2937;
  margin: 0;
`;
